import React, { useState } from 'react';
import { CPagination, CPaginationItem } from "@coreui/react";
import "./Pagination.css";

const Pagination = ({
  totalPosts,
  postsPerPage,
  setCurrentPage,
  currentPage,
}) => {
  // State to track the current page
  const [currpage, setcurrpage] = useState(1);
  const [shiftPages, setShiftPages] = useState(false); // Track if the pages should shift

  // Calculate total pages based on total posts and posts per page
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  // Function to handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    setcurrpage(page);
    setShiftPages(false); // Reset shiftPages when directly clicking on a page
  };

  // Function to handle the next button click
  const handleNextClick = () => {
    if (currpage < totalPages) {
      setCurrentPage(currpage + 1);
      setcurrpage(currpage + 1);
      setShiftPages(true); // Set shiftPages only when "Next" button is clicked
    }
  };

  // Determine the starting and ending pages for visibility
  let startingpage = shiftPages ? currpage : 1;
  let endingpage = Math.min(startingpage + 4, totalPages); // Ensure ending page does not exceed total pages
  const visiblePages = Array.from({ length: endingpage - startingpage + 1 }, (_, i) => startingpage + i);

  return (
    <>
      <div className="pagination">
        {/* Previous Page Link */}
        <a
          href="#"
          className={currpage === 1 ? "disabled" : ""}
          onClick={(e) => {
            e.preventDefault();
            if (currpage > 1) handlePageChange(currpage - 1);
          }}
        >
          &laquo;
        </a>

        {/* Page Number Links */}
        {visiblePages.map((page) => (
          <a
            key={page}
            href="#"
            className={page === currentPage ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handlePageChange(page);
            }}
          >
            {page}
          </a>
        ))}

        {/* Next Page Link */}
        <a
          href="#"
          className={currpage === totalPages ? "disabled" : ""}
          onClick={(e) => {
            e.preventDefault();
            handleNextClick();
          }}
        >
          &raquo;
        </a>
      </div>
    </>
  );
};

// export default Pagination;


export default Pagination;
